import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the checkout page an "Abandoned checkouts" crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/abandoned-checkouts')({
  staticData: { crumb: 'common:nav.abandonedCheckouts' },
  component: Outlet,
});
